(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TabletDetailController', TabletDetailController);

    TabletDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tablet'];

    function TabletDetailController($scope, $rootScope, $stateParams, previousState, entity, Tablet) {
        var vm = this;

        vm.tablet = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:tabletUpdate', function(event, result) {
            vm.tablet = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
